
export default function detectLangNested(array,path, lang,no) {
    if(array === undefined){
        return ""
    }else {
        function getNestedTranslation(lang, keys,no) {
            return keys.reduce((obj, key) => {
                return obj?.[`${key}_${no}_${lang ? lang : 'sp'}`];
            }, array);
        }
        const paths = path.split(".");
        return (
            getNestedTranslation(lang, paths,no) ??
            getNestedTranslation(lang, paths,no) ??
            paths
        );
    }
}